<template>
  <div id="app">
    <my-header v-if="$route.name !='SetAim' && $route.name !='SetAimDetails'"></my-header>
    <router-view v-if="isRouter"/>
    <my-footer v-if="isRouter && $route.name !='SetAim' && $route.name !='SetAimDetails'" ></my-footer>
    <div class="go-top" @click="goTop()">
      <div>
        <i></i>
        <p>TOP</p>
      </div>
    </div>
    <div class="loading-popup" v-if="$store.state.isShowloading"><i></i></div>
  </div>
</template>

<script>
import Header from './components/default/Header.vue';
import Footer from './components/default/Footer.vue';
export default {
  name: 'App',
  provide(){
    return{
      reload:this.reload
    };
  },
  data(){
    return{
      isRouter:true,
    }
  },
  watch:{
    '$route'(){
      //console.log(this.$route.name)
    }
  },
  methods:{
    goTop(){
       var timer = null;
      //document.documentElement.scrollTop = 0;
        cancelAnimationFrame(timer);
         timer = requestAnimationFrame(function fn(){
           var oTop = document.body.scrollTop || document.documentElement.scrollTop;
           if(oTop > 0){
             scrollTo(0,oTop-100);
             timer = requestAnimationFrame(fn);
           }else{
             cancelAnimationFrame(timer);
           }
         });
    },
    reload(){
      this.isRouter=false;
      this.$nextTick(function(){
        this.isRouter=true;
      })
    }    
  },
  components:{
    'my-header': Header,
    'my-footer': Footer
  }
}
</script>

<style>
  .loading-popup{
    width: 100%;
    height: 100vh;
    position: fixed;
    top: 0;
    left:0;
    background: rgba(0,0,0,0.2);
    z-index: 9999;
  }
  .loading-popup i{
    width: 50px;
    height: 50px;
    background: url('./assets/images/loading.gif') no-repeat center center;
    background-size: 100%;
    display: block;
    position: absolute;
    top: 50%;
    margin-top: -25px;
    left: 50%;
    margin-left: -25px;   
  }
</style>



// WEBPACK FOOTER //
// src/App.vue